import { render, staticRenderFns } from "./BusinessVoucher.vue?vue&type=template&id=372cbb6e&scoped=true"
import script from "./BusinessVoucher.vue?vue&type=script&lang=js"
export * from "./BusinessVoucher.vue?vue&type=script&lang=js"
import style0 from "./BusinessVoucher.vue?vue&type=style&index=0&id=372cbb6e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "372cbb6e",
  null
  
)

export default component.exports